'use client';
import { JumboCard, JumboScrollbar } from 'themes/jumbo/@jumbo/components';
import {
  Chip,
  Typography,
  Button,
  Tooltip,
  useTheme
} from '@mui/material';
import { DemosList } from './components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trackEvent } from "components/Tracking";

const DemosCard = ({title}:{title:React.ReactNode}) => {
	const _projects = useSelector((state: any) => state.cache.data.projects);
  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  const demos = Object.values(_projects).filter((item: any) => defaultProjects.includes(item.ID));

  const history = useHistory();
  const handleClick = (e: any) => {
    trackEvent("Dashboard", "Demos", "Btn_All");
    history.push(`/catalog/tabs/demos`);
  };
  const theme = useTheme();

  const CardTitle = () => (
    <div style={{display: "flex", justifyContent: 'space-between'}}>
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        <Typography color={'text.primary'} variant={'h6'} mb={0}>
          {title}
        </Typography>
        <Chip
          size={'small'}
          label={demos.length}
          color='success'
          sx={{
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            transform: 'scale(.8)'
          }}
        />
      </div>
      { demos.length > 0 && (
        <Tooltip title="All Demos" placement="top" arrow>
          <Button
            size={'small'}
            variant={'outlined'}
            onClick={handleClick} 
            style={{height: '25px', minWidth: 'auto'}}
          >
            All
          </Button>
        </Tooltip>
      )}
    </div>
  )

  return (
    <JumboCard
      title={<CardTitle />}
      contentWrapper
      contentSx={{ p: 0, minHeight: '150px' }}
    >
      <JumboScrollbar autoHeight autoHeightMin={100}>
        <DemosList demos={demos} />
      </JumboScrollbar>
    </JumboCard>
  );
};

export { DemosCard };
